<template>
  <div class="title-container">
    <div class="title-sub title-sub__left">
      <title-sub content="项目地图"></title-sub>
      <title-sub content="曲线报表"></title-sub>
    </div>
    <title-main zh-content="亿测云<br>物联网平台"></title-main>
    <div class="title-sub title-sub__right">
      <title-sub content="数据报表"></title-sub>
      <div @click="handleFull">
        <title-sub :content="this.isFull ? '退 出' : '全屏显示'"></title-sub>
      </div>
    </div>
  </div>
</template>

<script>
import TitleSub from './components/TitleSub'
import TitleMain from './components/TitleMain'
export default {
  name: 'ScreenTitle',
  components: {
    TitleMain,
    TitleSub
  },
  props: {
    isFull: Boolean
  },
  methods: {
    handleFull() {
      // this.text = this.isFull ? '关闭' : '全屏'
      this.$emit('full', !this.isFull)
    }
  }
}
</script>

<style lang='less' scoped>
.title-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  .title-sub {
    display: flex;
    justify-content: center;
    position: relative;
    &.title-sub__left {
      left: 40px;
    }
    &.title-sub__right {
      right: 40px;
    }
  }
}
</style>
